import { Chat, ModelConversation } from 'types/chat';

export function buildModelsFromSettings(
  mode: Chat['mode'],
  expertModelIds: string[],
  summaryModelId: string | null,
  modelNameById: Map<string, string>,
): ModelConversation[] {
  const result: ModelConversation[] = [];

  if (mode === 'single') {
    const id = expertModelIds[0] ?? 'default';
    result.push({
      id,
      name: modelNameById.get(id) ?? id,
      expertRole: 'expert',
      order: 1,
      messages: [],
      status: 'active',
    });
    return result;
  }

  if (summaryModelId) {
    result.push({
      id: summaryModelId,
      name: modelNameById.get(summaryModelId) ?? summaryModelId,
      expertRole: 'summary',
      order: 1,
      messages: [],
      status: 'active',
    });
  }

  expertModelIds.forEach((id) => {
    result.push({
      id,
      name: modelNameById.get(id) ?? id,
      expertRole: 'expert',
      order: result.length + 1,
      messages: [],
      status: 'active',
    });
  });

  return result;
}
